import React, { Component } from 'react';
import './Testimonial.css';

import MohitImg from '../../Assets/Img/testimonial/mohit-singh.jpg';
import SachinImg from '../../Assets/Img/testimonial/sachin-vaid.jpg';
import HarshitImg from '../../Assets/Img/testimonial/harshit-gupta.jpg';
import AshishImg from '../../Assets/Img/testimonial/ashish-dawar.jpg';
import SameerImg from '../../Assets/Img/testimonial/sameer-singh.jpg';

const testimonials = [
  {
    img: SachinImg,
    name: 'Sachin Vaid',
    role: 'Engineering Lead',
    company: 'Daffodil Software',
    text: 'I am writing to highly recommend Rudraksh for any professional opportunity. During our time working together, I have been consistently impressed with Rudraksh\'s exceptional skills in different programming languages and his quick learning ability. Not only is Rudraksh a skilled programmer, but he is also an outstanding application architect. His ability to understand complex business requirements and design effective solutions has been a great asset to our team. I would highly recommend Rudraksh for any role that requires a skilled programmer, a talented application architect, or a great people manager.'
  },
  {
    img: MohitImg,
    name: 'Mohit Kumar Singh',
    role: 'Delivery Manager',
    company: 'Daffodil Software',
    text: 'Rudraksh Pathak is an exceptional professional with a passion for technology and a dedication to his work. He is a technology enthusiast who is always open to working on new and emerging technologies. He is eager to learn and experiment with new tools and frameworks, which has made him a valuable asset to our team. His dedication to his work is second to none, and he is always willing to go above and beyond to ensure that projects are completed on time and to the highest standards.'
  },
  {
    img: HarshitImg,
    name: 'Harshit Gupta',
    role: 'Application Architect',
    company: 'Daffodil Software',
    text: 'It is my pleasure to highly recommend Rudraksh. We worked together for almost 5 years and I have seen him grow from a software developer to a tech lead and application architect. He is always a go-to man for a manager as he delivers solutions beyond expectations and is so sound technically that he always impresses with his work. Along with all his technical capabilities and skills, he is also a great human being with empathy.'
  },
  {
    img: AshishImg,
    name: 'Ashish Dawar',
    role: 'Project Manager',
    company: 'Daffodil Software',
    text: 'Rudraksh is truly a valuable team member. During our time working together, I have found him to be extremely knowledgeable and smart. What impressed me the most was when he transformed from a PHP developer to a .NET developer — he quickly learned new technologies and adapted to new challenges. Moreover, his leadership qualities are impressive. He became a lead and a pivotal member of our team.'
  },
  {
    img: SameerImg,
    name: 'Sameer Singh',
    role: 'Application Architect',
    company: 'Daffodil Software',
    text: 'Rudraksh served as an Application Architect during his tenure with us and consistently demonstrated exceptional technical and leadership skills. His technical expertise, attention to detail, and commitment to delivering high-quality work makes him an invaluable member of any project team. He is a team player with excellent communication skills and a positive attitude.'
  }
];

class Testimonial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      isPaused: false
    };
  }

  componentDidMount() {
    this.startAutoSlide();
  }

  componentWillUnmount() {
    this.stopAutoSlide();
  }

  startAutoSlide = () => {
    this.interval = setInterval(() => {
      if (!this.state.isPaused) {
        this.nextSlide();
      }
    }, 7000);
  };

  stopAutoSlide = () => {
    if (this.interval) clearInterval(this.interval);
  };

  nextSlide = () => {
    this.setState(prev => ({
      currentIndex: (prev.currentIndex + 1) % testimonials.length
    }));
  };

  prevSlide = () => {
    this.setState(prev => ({
      currentIndex: (prev.currentIndex - 1 + testimonials.length) % testimonials.length
    }));
  };

  setSlide = (index) => {
    this.setState({ currentIndex: index });
  };

  handleMouseEnter = () => {
    this.setState({ isPaused: true });
  };

  handleMouseLeave = () => {
    this.setState({ isPaused: false });
  };

  render() {
    const { currentIndex } = this.state;
    const current = testimonials[currentIndex];

    return (
      <div
        className="testimonial-custom-slider"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="testimonial-card-main animate-fade-in" key={currentIndex}>
          <div className="testimonial-grid">
            <div className="testimonial-author-block">
              <div className="testimonial-avatar-ring">
                <img src={current.img} alt={current.name} />
              </div>
              <h4 className="testimonial-name">{current.name}</h4>
              <p className="testimonial-role">{current.role}</p>
              <span className="testimonial-company">{current.company}</span>
              <a
                href="https://www.linkedin.com/in/rudrakshpathak/details/recommendations/?detailScreenTabIndex=0"
                target="_blank"
                rel="noopener noreferrer"
                className="testimonial-linkedin-btn"
                title="View LinkedIn Recommendations"
              >
                <i className="fa fa-linkedin-square"></i>
                <span>Verified on LinkedIn</span>
              </a>
            </div>

            <div className="testimonial-quote-block">
              <div className="quote-icon">“</div>
              <blockquote className="quote-content">
                {current.text}
              </blockquote>
            </div>
          </div>
        </div>

        {/* CONTROLS */}
        <div className="testimonial-controls-bar">
          <button
            type="button"
            className="slider-arrow prev"
            onClick={this.prevSlide}
            aria-label="Previous recommendation"
          >
            <i className="fa fa-chevron-left"></i>
          </button>

          <div className="slider-dots">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                type="button"
                className={`slider-dot ${idx === currentIndex ? 'active' : ''}`}
                onClick={() => this.setSlide(idx)}
                aria-label={`Go to slide ${idx + 1}`}
              ></button>
            ))}
          </div>

          <button
            type="button"
            className="slider-arrow next"
            onClick={this.nextSlide}
            aria-label="Next recommendation"
          >
            <i className="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    );
  }
}

export default Testimonial;
